<template>
  <div>
    <template>
      <v-form ref="form" lazy-validation>
        <v-col flat color="white" class="mt-1" cols="12" sm="3">
          <v-select
            class="mr-3 pt-4"
            :items="targetDateType"
            inputmode="tel"
            item-value="code"
            item-text="code_name"
            v-model="selectDateType"
            label="曜日指定タイプ"
            @input="GetSettingDaysList"
          ></v-select>
          <v-spacer></v-spacer>
        </v-col>
      </v-form>
    </template>
    <v-data-table
      :headers="headers"
      :items="desserts"
      class="golfGroupTbody"
      hide-default-footer
    >
      <template v-slot:[`item.flags`]="{ item }">
        <v-simple-checkbox v-model="item.flags" disabled/>
      </template>
      <template v-slot:[`item.Btn`]="{ item }">
        <v-btn color="green darken-4" text @click="EditModal(item)" class="editBtn" :disabled="btn[3].isActive">変更</v-btn>
      </template>
      <template v-slot:[`item.deleteBtn`]="{ item }">
        <v-btn text @click="RemoveOverlayStart(item)" class="deleteBtn" :disabled="btn[4].isActive">削除</v-btn>
      </template>
    </v-data-table>
    <v-pagination
      class="my-2"
      v-model="page"
      :length="pageCount"
      :total-visible="7"
      @input="ClickPagination"
    />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-4" text @click="AddModal" :disabled="btn[2].isActive">追加</v-btn>
    </v-card-actions>
    <RemoveOverlay
      page-name="祝日"
      @processing="DeleteHoliday"
      @cancel="removeOverlay = !removeOverlay"
      :dblclickStop="processing"
      :process-result="process"
      :OverlaySwitch="removeOverlay"
    />
    <HolidayModal ref="HolidayModalView" v-show="showHolidayModal" v-on:from-Dialog="OnCloseEditModal"/>
  </div>
</template>

<script>
import HolidayModal from './modal/HolidayModal';
import { DELETE_SETTING_DAYS, GET_SETTING_DAYS_LIST } from '@/constants/setting_days';
import { authorityMixin } from '@/views/authorityMixin';
import RemoveOverlay from '../page/overlay/RemoveOverlay';
import { GET_CODE_KEY_LIST } from '@/constants/codelist';
import { CODE_MASTER } from '../../config';

export default {
    components: {
        HolidayModal,
        RemoveOverlay
    },
    mixins: [authorityMixin],
    data () {
        return {
            showHolidayModal: false,
            page: 1,
            golfCode: '',
            pageCount: 0,
            begin_row: 0,
            limit_rows: 10,
            removeOverlay: false,
            targetDateType: [],
            selectDateType: '1',
            // 削除モーダル用変数
            removeMonthDay: null,
            removeDateName: null,
            processing: false,
            // エラーメッセージ
            error: '',
            // 処理結果
            process: {
                result: '',
                resultText: ''
            },
            GolfCourseList: [],
            // v-data-tableのアイテム
            desserts: [],
            // v-data-tableのヘッダー
            headers: [],
            // ログイン者の情報
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // ボタン制御
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '参照', isActive: true },
                { element_id: '002', element_name: '追加', isActive: true },
                { element_id: '003', element_name: '変更', isActive: true },
                { element_id: '004', element_name: '削除', isActive: true }
            ],
            // 曜日表示用リスト
            weekDaysLists: [
                { code: '00', weekDaysName: '日曜日' },
                { code: '01', weekDaysName: '月曜日' },
                { code: '02', weekDaysName: '火曜日' },
                { code: '03', weekDaysName: '水曜日' },
                { code: '04', weekDaysName: '木曜日' },
                { code: '05', weekDaysName: '金曜日' },
                { code: '06', weekDaysName: '土曜日' }
            ],
            vue_id: 'SCR0010'
        };
    },
    computed: {
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.admin = await this.getLoginAdmin();
            this.GetFlagCodeList();
            this.getAuthorityList();
            await this.GetSettingDaysList();
        },
        /** --------------------------------------------
        * 祝日リスト取得
        * -------------------------------------------- */
        async GetSettingDaysList () {
            let res = await this.$apollo.mutate({
                mutation: GET_SETTING_DAYS_LIST,
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    date_type: this.selectDateType,
                    limit_rows: this.limit_rows,
                    begin_row: this.begin_row
                }
            });
            let resDaysList = res.data.GetSettingDaysListByMaster.SettingDaysList;
            for (var i = 0; i < resDaysList.length; i++) {
                resDaysList[i].flags = Boolean(resDaysList[i].valid_flag);
            }
            const count = res.data.GetSettingDaysListByMaster.count;
            this.pageCount = Math.ceil(count / 10);
            this.desserts = resDaysList;

            // 日付固定の場合の表示処理
            if (this.selectDateType === CODE_MASTER.DATE_TYPE_FIXED_DATE) {
                for (var j = 0; j < resDaysList.length; j++) {
                    var month = resDaysList[j].month_day.substr(0, 2);
                    var day = resDaysList[j].month_day.substr(2, 3);
                    this.desserts[j].monthday = month + '-' + day;
                    this.headers = [
                        { text: '日付', value: 'monthday', align: 'center', sortable: false },
                        { text: '祝日名称', value: 'date_name', align: 'center', sortable: false },
                        { text: '', value: 'Btn', sortable: false },
                        { text: '', value: 'deleteBtn', sortable: false }
                    ];
                }

            // 対象日指定の場合の表示処理
            } else if (this.selectDateType === CODE_MASTER.DATE_TYPE_TARGET_DATE) {
                for (var k = 0; k < resDaysList.length; k++) {
                    this.desserts[k].month = resDaysList[k].month_day.substr(0, 2);
                    /* var l = this.desserts[j].month.replace(/[1]/g,"");
                    console.log(l); */
                    this.desserts[k].week = resDaysList[k].month_day.substr(2, 2);
                    this.desserts[k].displayWeek = this.desserts[k].week.replace(/^[0]/, '');
                    this.desserts[k].weekDay = resDaysList[k].month_day.substr(4, 5);
                    this.desserts[k].displayMonth = this.desserts[k].month.replace(/^[0]/, '');
                    this.desserts[k].weekDays = this.weekDaysLists.find(data => data.code === this.desserts[k].weekDay);
                    this.headers = [
                        { text: '月', value: 'displayMonth', align: 'center', sortable: false },
                        { text: '週', value: 'displayWeek', align: 'center', sortable: false },
                        { text: '曜日', value: 'weekDays.weekDaysName', align: 'center', sortable: false },
                        { text: '祝日名称', value: 'date_name', align: 'center', sortable: false },
                        { text: '', value: 'Btn', sortable: false },
                        { text: '', value: 'deleteBtn', sortable: false }
                    ];
                }
            }
        },
        /** --------------------------------------------
        * コードリスト取得
        * -------------------------------------------- */
        GetFlagCodeList: async function () {
            try {
                let res = await this.$apollo.mutate({
                    mutation: GET_CODE_KEY_LIST,
                    variables: {
                        codeKeyList: ['date_type', 'day_of_week']
                    }
                });
                /* console.log(res.data.GetCodeListByKeys.CodeKeyRecList); */
                this.targetDateType = res.data.GetCodeListByKeys.CodeKeyRecList[0].codeRec;/* find(data => data.code_key === 'date_type'); */
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
        * 削除ボタン押下
        * -------------------------------------------- */
        RemoveOverlayStart (item) {
            this.removeOverlay = true;
            this.removeMonthDay = item.month_day;
            this.removeDateName = item.date_name;
        },
        /** --------------------------------------------
        * 祝日削除
        * -------------------------------------------- */
        DeleteHoliday: async function (item) {
            // 二重送信防止処理
            if (this.processing) return;

            try {
                await this.$apollo.mutate({
                    mutation: DELETE_SETTING_DAYS,
                    variables: {
                        golf_group_code: process.env.VUE_APP_GROUP_CODE,
                        month_day: this.removeMonthDay,
                        date_name: this.removeDateName,
                        date_type: this.selectDateType
                    }
                }).then(res => {
                    this.processing = false;
                    this.removeOverlay = false;
                    this.GetSettingDaysList();
                });
            } catch (error) {
                this.result = 0;
                // 削除失敗時
                this.resultText = this.$t('result.error.remove');
                this.error = error;
                this.processing = false;
            }
        },
        /** --------------------------------------------
        * 編集モーダルを開く
        * -------------------------------------------- */
        EditModal (item) {
            this.showHolidayModal = true;
            this.$refs.HolidayModalView.EditModal(item, this.selectDateType);
        },
        /** --------------------------------------------
        * 追加モーダルを開く
        * -------------------------------------------- */
        AddModal () {
            this.showHolidayModal = true;
            this.$refs.HolidayModalView.AddModal(this.selectDateType);
        },
        /** --------------------------------------------
        * モーダル画面閉じる
        * -------------------------------------------- */
        OnCloseEditModal () {
            this.initialize();
            this.showHolidayModal = false;
        },
        /** --------------------------------------------
        * ページネーション
        * -------------------------------------------- */
        ClickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.GetSettingDaysList();
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }
</style>
